import { PublicMenu } from "../components/public";

type StudentLayoutProps = {
    children: React.ReactNode;
}

export const StudentLayout = ({ children }: StudentLayoutProps) => {
    return (
        <>
            <PublicMenu/>
                {children}
            </>
            )
}
